import React from 'react';

import type { PanAnimationConfig } from './types';

export const panConfigDefault: PanAnimationConfig = {
  title: 'POWERS THROUGH THE TOUGHEST STAINS',
  subtitle: 'SWIPE TO REVEAL DISCOUNT​​',
  completedTitle: 'Congratulations!',
  completedSubtitle: 'Copy & use your exclusive Finish discount code',

  skipButtonText: 'Skip & Reveal my Discount Code',

addInfoText: (
  <>
   *Code entitles you to 20% off on advertised products on Amazon. Redeem by entering the code at Amazon checkout. Valid until 30/11/2026.
  </>
),

  revealedTitle: (
    <>
      <span>SAVE 20% OFF </span> <br /> ON OUR BEST FINISH 
    </>
  ),
  revealedSubText:
    'To help you with your dishwashing journey, here’s an exclusive discount just for you',

  copyButton: 'Copy',
  copiedButton: 'Copied',
  discountSubText: 'Your Discount Code',
  couponCode: '2025FINISH20',
  retailerButton: 'Go to Amazon and Redeem',
  retailerUrl: 'https://www.amazon.ae/stores/page/AF18732C-0FB1-4791-BE2F-F3E4D6529C59/?_encoding=UTF8&store_ref=SB_A0797072K2MBNJLN7FJ7-A099091316GHBP63L1F5R&pd_rd_plhdr=t&aaxitk=e67648db3b5532f228196a970b962033&hsa_cr_id=0&lp_asins=B0DCVZV3JG%2CB0DBQZGT3N%2CB0GS6LJYV6%2CB0GX11NK12%2CB0G7D25F44%2CB0GMK9SNLF&lp_query=finish%20dishwasher%20tablets&lp_slot=auto-sparkle-hsa-tetris&sdp_ad_group=300187199056534&i=aps&aref=nKikLXdWF3&ref_=sbx_s_sparkle_sbtcd_cta&pd_rd_w=pFrKS&content-id=amzn1.sym.3a93fa1b-6acd-4565-a24e-8950875d6b37%3Aamzn1.sym.3a93fa1b-6acd-4565-a24e-8950875d6b37&pf_rd_p=3a93fa1b-6acd-4565-a24e-8950875d6b37&pf_rd_r=QHA5BKJSGJ777TADH74S&pd_rd_wg=zVnfS&pd_rd_r=7e8943bc-104a-4eb5-b764-46c981fc1a15',

  promoId: '89b57a52-246c-49ce-883a-be7e9717d253',
};

export const panConfigAR: PanAnimationConfig = {
  title: 'يتغلّب على أصعب البقع',
  subtitle: 'اسحب للكشف عن الخصم',
  completedTitle: 'مبروك!',
  completedSubtitle: 'انسخ واستخدم كود الخصم الخاص بك من فينيش.',

  skipButtonText: 'تخطَّ تنظيف الطاسة واكشف كود الخصم',

   addInfoText: (
    <>
     *يمنحك هذا الرمز للحصول على خصم 20% على المنتجات المُعلن عنه على أمازون. أدخل الرمز عند إتمام الطلب على أمازون. العرض ساري حتى 30/11/2026
    </>
  ),   



  revealedTitle: (
    <>
      <span>وفر %20</span> <br /> على أقراص فينيش أمازون ألتيميت بلس
    </>
  ),
  revealedSubText: 'لنساعدك في رحلتك مع غسيل الأطباق، استمتع بخصم حصري لك من فنش',
  revealedSubtitle: 'تهانينا! انسخ واستخدم رمز الخصم الخاص بك من فنش',

  copyButton: 'انسخ',
  copiedButton: 'تم النسخ',
  discountSubText: 'رمز الخصم الخاص بك',
  couponCode: '2025FINISH20',
  retailerButton: 'تسوّق الآن على أمازون',
  retailerUrl: 'https://www.amazon.ae/stores/page/AF18732C-0FB1-4791-BE2F-F3E4D6529C59/?_encoding=UTF8&store_ref=SB_A0797072K2MBNJLN7FJ7-A099091316GHBP63L1F5R&pd_rd_plhdr=t&aaxitk=e67648db3b5532f228196a970b962033&hsa_cr_id=0&lp_asins=B0DCVZV3JG%2CB0DBQZGT3N%2CB0GS6LJYV6%2CB0GX11NK12%2CB0G7D25F44%2CB0GMK9SNLF&lp_query=finish+dishwasher+tablets&lp_slot=auto-sparkle-hsa-tetris&sdp_ad_group=300187199056534&i=aps&aref=nKikLXdWF3&ref_=sbx_s_sparkle_sbtcd_cta&pd_rd_w=pFrKS&content-id=amzn1.sym.3a93fa1b-6acd-4565-a24e-8950875d6b37%3Aamzn1.sym.3a93fa1b-6acd-4565-a24e-8950875d6b37&pf_rd_p=3a93fa1b-6acd-4565-a24e-8950875d6b37&pf_rd_r=QHA5BKJSGJ777TADH74S&pd_rd_wg=zVnfS&pd_rd_r=7e8943bc-104a-4eb5-b764-46c981fc1a15&language=ar_AE',

  promoId: '89b57a52-246c-49ce-883a-be7e9717d253',
};

export const panConfigSA: PanAnimationConfig = {
  title: 'POWERS THROUGH THE TOUGHEST STAINS',
  subtitle: 'SWIPE TO REVEAL DISCOUNT​​',
  completedTitle: 'Congratulations!',
  completedSubtitle: 'Copy & use your exclusive Finish discount code',

  skipButtonText: 'Skip & Reveal my Discount Code',

  addInfoText: (
    <>
      *Code entitles you to 20% off on advertised products on Amazon. Redeem by entering the code at Amazon checkout. Valid until 30/11/2026.
    </>
  ),

  revealedTitle: (
    <>
      <span>SAVE 20% OFF </span> <br /> ON OUR BEST FINISH
    </>
  ),
  revealedSubText:
    'To help you with your dishwashing journey, here’s an exclusive discount just for you',
  revealedSubtitle: 'Congratulations! Copy & use your exclusive Finish discount code',

  copyButton: 'Copy',
  copiedButton: 'Copied',
  discountSubText: 'Your Discount Code',
  couponCode: 'FINISH20',
  retailerButton: 'Go to Amazon and Redeem',
  retailerUrl: 'https://www.amazon.sa/stores/FinishTablets/page/D39B6D8B-0247-45E8-BE20-1113EDB31AE5?dplnkId=7c2ea996-1b0d-4f38-b4a5-1646f17947da&ref=d6k_universal&dplnk=Y&ref_=cm_sw_r_apin_ast_store_QAZ576R0V1KK1901022Z&language=en_AE#msdynmkt_trackingcontext=495975d3-7c25-4dff-ae7b-8de9697d0100',

  promoId: '89b57a52-246c-49ce-883a-be7e9717d253',
};

export const panConfigSAAR: PanAnimationConfig = {
  title: 'يتغلّب على أصعب البقع',
  subtitle: 'اسحب للكشف عن الخصم',
  completedTitle: 'مبروك!',
  completedSubtitle: 'انسخ واستخدم كود الخصم الخاص بك من فينيش.',

  skipButtonText: 'تخطَّ تنظيف الطاسة واكشف كود الخصم',

  addInfoText: (
    <>
      *يمنحك هذا الرمز للحصول على خصم 20% على المنتجات المُعلن عنه على أمازون. أدخل الرمز عند إتمام
      الطلب على أمازون. العرض ساري حتى 30/11/2026
    </>
  ),

  revealedTitle: (
    <>
      <span>وفر %20</span> <br /> على أقراص فينيش أمازون ألتيميت بلس
    </>
  ),
  revealedSubText: 'لنساعدك في رحلتك مع غسيل الأطباق، استمتع بخصم حصري لك من فنش',
  revealedSubtitle: 'تهانينا! انسخ واستخدم رمز الخصم الخاص بك من فنش',

  copyButton: 'انسخ',
  copiedButton: 'تم النسخ',
  discountSubText: 'رمز الخصم الخاص بك',
  couponCode: 'FINISH20',
  retailerButton: 'تسوّق الآن على أمازون',
  retailerUrl: 'https://www.amazon.sa/stores/FinishTablets/page/D39B6D8B-0247-45E8-BE20-1113EDB31AE5?dplnkId=7c2ea996-1b0d-4f38-b4a5-1646f17947da&ref=d6k_universal&dplnk=Y&ref_=cm_sw_r_apin_ast_store_QAZ576R0V1KK1901022Z&language=ar-AE#msdynmkt_trackingcontext=495975d3-7c25-4dff-ae7b-8de9697d0100',

  promoId: '89b57a52-246c-49ce-883a-be7e9717d253',
};
